import { ShopperAgentCapabilityKind } from "@redotech/redo-shopper-agent-common/capabilities/shopper-agent-capabilities";
import * as z from "zod";

/**
 * What Commerce Agent can do for this team right now.
 *
 * Team-level, unlike the admin equivalent, which answers for one conversation.
 * Availability is derived from other products' settings, so nothing here is
 * merchant-editable; the UI links out to whichever page governs each one.
 */
export const getCommerceAgentCapabilities = {
  name: "getCommerceAgentCapabilities" as const,
  input: z.object({}),
  output: z.object({
    capabilities: z.array(
      z.object({
        kind: z.enum(ShopperAgentCapabilityKind),
        available: z.boolean(),
        /** Present when the capability works but is partly restricted. */
        warning: z.string().optional(),
      }),
    ),
  }),
};
